import { Box, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import { BentoBrand } from "schemas/dashboard";

const styles = {
  clamped: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  expanded: {
    whiteSpace: "normal",
  },
};

export default function AboutSummary({
  bentoBrand,
  expanded,
}: {
  bentoBrand: BentoBrand;
  expanded: boolean;
}) {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  if (!bentoBrand.aboutSummary) return <></>;

  return (
    <>
      <Typography
        color="textSecondary"
        sx={{
          fontSize: 12,
          mb: 0,
          ...(expanded ? styles.expanded : styles.clamped),
        }}
      >
        {bentoBrand.aboutSummary}
      </Typography>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        {!isMobileScreen && (
          <Link
            sx={{
              textDecoration: "underline",
              fontSize: 12,
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer",
              textUnderlineOffset: "3px",
              fontWeight: 600,
            }}
          >
            {expanded ? "View Less" : "Learn More"}
          </Link>
        )}
      </Box>
    </>
  );
}
